module.exports = __webpack_public_path__ + "static/media/altfi.049d0dec.jpg";